import React, {useRef, useState, useEffect} from 'react';
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  Image,
  TouchableOpacity,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import loadable from '@loadable/component';
import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import {isWeb} from '../../../../../constants';
import BottomSheet from 'src/components/bottom-sheet';
import {showSheet} from '../../../../../actions/SheetActions';
import styles from './EndImage.style';
import EmptyBox from '../../../../../components/empty-box/EmptyBox.component';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
const SVG = loadable(() => import('../../../../../imports/svg'));
const windowWidth = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const originalWidth = windowWidth;
const originalHeight = windowWidth;
const aspectRatio = 1.1;

const EndImageLearn = () => {
  const bottomSheetRef = useRef(null);
  const dispatch = useDispatch();
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const {t} = useTranslation();
  const [activeTab, setActiveTab] = useState('motor');
  const selectedItem = useSelector(state => state.learn.selectedItem);
  console.log(selectedItem, 'selectedItem');
  const tabs = [
    {key: 'bike', label: t('electric_bike')},
    {key: 'motor', label: t('electric_motor')},
  ];
  const closeBottomSheet = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  const closeBottomSheet1 = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };
  return (
    <BottomSheet
      ref={bottomSheetRef}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [height * 0.98]}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(
                  showSheet({
                    sheetId: '',
                  }),
                );
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? height * 0.98 : undefined}
      open={sheetProps?.visible}
      isScrollView={isWeb ? undefined : true}
      handleIndicatorStyle={
        !isWeb ? {backgroundColor: 'transparent'} : undefined
      }
      onClose={closeBottomSheet1}>
      <View style={styles.container}>
        <View style={styles.header}>
          <FabBackButton
            container_style={styles.closeBtn}
            onPress={closeBottomSheet}
            icon={'closeIcon'}
          />
          <Text style={styles.headerTitle}>{selectedItem?.Title}</Text>
        </View>

        {/* Tabs */}
        <View style={styles.tabs}>
          {tabs.map(tab => (
            <TouchableOpacity
              key={tab.key}
              style={[styles.tab, activeTab === tab.key && styles.activeTab]}
              onPress={() => setActiveTab(tab.key)}>
              <Text
                style={[
                  styles.tabText,
                  activeTab === tab.key && styles.activeTabText,
                ]}>
                {tab.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
        <View style={styles.cardsContainer}>
          {selectedItem?.Items.filter(item => {
            if (activeTab === 'motor') return item.VehicleType === 2;
            if (activeTab === 'bike') return item.VehicleType === 1;
            return true;
          })
            .reverse()
            .map(item => (
              <View
                key={item.id}
                style={[styles.card, {width: windowWidth / 1.2, aspectRatio}]}>
                <Image
                  source={{uri: item.Link}}
                  style={styles.map}
                  resizeMode="cover"
                />

                <View style={styles.cardIcon}>
                  {item.Status === false ? (
                    <SVG
                      name={'Incorrect'}
                      width={windowWidth * 0.06}
                      height={windowWidth * 0.06}
                      color="red"
                    />
                  ) : (
                    <SVG
                      name={'Correct'}
                      width={windowWidth * 0.06}
                      height={windowWidth * 0.06}
                      color="green"
                    />
                  )}
                </View>
              </View>
            ))}
        </View>
        <EmptyBox height={height * 0.1} />
        <View
          style={[
            {width: '95%', minHeight: 60, paddingHorizontal: 8, marginTop: 30},
          ]}>
          <Text style={styles.description}>
            در انتهای سفر از وسیله ۰.۵ تا ۱ متر فاصله بگیرید بطوریکه پلاک و بسته
            بودن قفل کابلی واضح باشد.
          </Text>

          {/* {activeTab === 'motor' ? (
            <>
              <Text style={[styles.description, {marginTop: 5}]}>توجه :</Text>
              <Text style={styles.description}>
              
              </Text>
            </>
          ) : (
            <>
              <Text style={[styles.description, {marginTop: 5}]}>توجه :</Text>
              <Text style={styles.description}>
                - پلاک روی بدنه زیرزین است.
              </Text>
            </>
          )} */}

          <Text style={[styles.description, {marginTop: 5}]}>توجه :</Text>
        {/* <View style={styles.container}>
  <View style={styles.textWrapper}> */}
  {/* <View style={styles.container2}> */}
    <Text style={styles.description2}>
      - در دوچرخه پلاک روی بدنه زیر زین است .
    </Text>
    <Text style={styles.description2}>
      - پلاک موتور پشت وسیله قرار دارد .
    </Text>
    {/* </View> */}
  {/* </View>
</View> */}
        </View>
        <EmptyBox height={height * 0.15} />
      </View>
    </BottomSheet>
  );
};

export default EndImageLearn;
